<div class="wizard-navigation-container" 
[ngClass]="{'start-step-container': isStartStep, 'fixed-navigation-mobile-stepOne': currentStepNumber === 1, 'fixed-navigation-mobile-stepTwo': currentStepNumber === 2, 'fixed-navigation-mobile-stepThree': currentStepNumber === 3, 'fixed-navigation-mobile-stepFour': currentStepNumber === 4}">  
<div class="navigation-button-container">
    <span *ngIf="!hideBackButton" class="back-button-container">
      <app-back-button
        [currentStepName]="currentStepName"
        [previousStepRoute]="previousStepRoute"
        [previousStepNumber]="getPreviousStepNumber()"
        [totalSteps]="totalSteps"></app-back-button>
    </span>
    <span>
    <app-continue-button
      [currentStepName]="currentStepName"
      [isStartStep]="isStartStep"
      [nextStepRoute]="nextStepRoute"
      [nextStepNumber]="getNextStepNumber()"
      [totalSteps]="totalSteps"
      [disableContinueButton]="disableContinueButton">
    </app-continue-button>
  </span>
  <button *ngIf="disableContinueButton && hasSkipButton" class="skip-button link" (click)="onSkip()">SKIP</button>
</div>
</div>
